export default {
    url: '/department/:id',
    template: '<user-group-detail-department department="vm.department"/>',
    resolve: {
        department (ClassifierResource, $stateParams) {
            return ClassifierResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (department) {
        this.department = department;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/detail/department/index.js